/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Tier__Free4Inputs */

const en_subscription_tier__free4 = /** @type {(inputs: Subscription_Tier__Free4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Subscription_Tier__Free4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const subscription_tier__free4 = /** @type {((inputs?: Subscription_Tier__Free4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Tier__Free4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_subscription_tier__free4(inputs)
});
export { subscription_tier__free4 as "subscription_tier__FREE" }